export default "__VITE_PUBLIC_ASSET__0af54fc4__"